import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
// import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { Subject, take } from 'rxjs'
import { AlertData } from '../../models/alert.model'

@Component({
    selector: 'restricted-product-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    imports: [MatButtonModule, MatIconModule, CommonModule]
})
export class AlertComponent {
  @Output() closed = new EventEmitter<void>()
  /** Data to the alert is passed as input */
  @Input() data!: AlertData
  @Input() closeable = true
  close$ = new Subject<void>()

  alertIcons = {
    error: 'error',
    success: 'check_circle',
    warning: 'warning',
    info: 'info',
  }

  /* istanbul ignore next */
  constructor() {
    this.close$.pipe(take(1)).subscribe(() => {
      this.closed.emit()
    })
  }
}
